import type { HTMLAttributes, ReactNode } from 'react';
import { cn } from '@/lib/utils';
import { badgeStyles } from './Badge.styles';

export type BadgeVariant = keyof typeof badgeStyles.variant;

export type BadgeProps = HTMLAttributes<HTMLSpanElement> & {
  variant?: BadgeVariant;
  children: ReactNode;
};

export function Badge({
  className,
  variant = 'neutral',
  children,
  ...props
}: BadgeProps): JSX.Element {
  return (
    <span className={cn(badgeStyles.base, badgeStyles.variant[variant], className)} {...props}>
      {children}
    </span>
  );
}
